/**
 * Get the display label for a round based on its index in an event
 * @param {number} roundIndex - Zero-based index of the round (0, 1, 2, etc.)
 * @param {number} totalRounds - Total number of rounds in the event (optional)
 * @returns {string} Display label for the round
 */
export function getRoundLabel(roundIndex, totalRounds = null) {
  // For single round events, don't show a label
  if (totalRounds === 1) {
    return '';
  }

  if (roundIndex === 0) {
    return 'Practice Round';
  }
  return `Championship Round ${roundIndex}`;
}

/**
 * Check if a round can be started based on event state
 * @param {Array} eventRounds - All rounds in the event, sorted by date
 * @param {number} roundIndex - Index of the round to check
 * @returns {object} { canStart: boolean, reason: string }
 */
export function canStartRound(eventRounds, roundIndex) {
  // First round can always start
  if (roundIndex === 0) {
    return { canStart: true, reason: '' };
  }

  // Check if previous round is completed
  const previousRound = eventRounds[roundIndex - 1];
  if (!previousRound) {
    return { canStart: false, reason: 'Previous round not found' };
  }

  if (previousRound.status !== 'completed') {
    const previousLabel = getRoundLabel(roundIndex - 1);
    return {
      canStart: false,
      reason: `${previousLabel} must be completed first`
    };
  }

  return { canStart: true, reason: '' };
}
